
/* Package JSON Import will be here */
import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useSelector } from "react-redux";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import TapIcon from 'assets/img/tap-iphone.png';
import AddIcon from 'assets/img/add-iphone.png';
import { isIosDevice } from "utilities/utils";
/* Project Import will be here */

const AddToHomeScreen = (props) => {
    const [isIos] = useState(isIosDevice());
    const [isInStandaloneMode] = useState(window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone);

    const { translate, logoutPersist } = useSelector((state) => ({
        translate: getTranslate(state.locale),
        logoutPersist: state.logoutPersist,
    }));

    const openPwaPopup = (evt) => {
        evt.preventDefault();

        /* close the menu dropdown */
        props.toggleAccount();

        if (!logoutPersist.promptInstall) {
            return;
        }
        logoutPersist.promptInstall.prompt();
    };

    /* Return null if the PWA option not supported */
    if ((!isIos && !logoutPersist.isSupportPwa) || (isIos && isInStandaloneMode)) {
        return null;
    }

    /* Check for client app name based on the customer */
    let clientAppName = translate("common.ivyMarketplace");
    if (window.clientAppName.trim() !== "")
        clientAppName = window.clientAppName;

    /* Return the input element to activate the add to home screen */
    const renderComp = () => {
        if (isIos) {
            return (
                <Modal
                    visible={props.isShowAddToHomeScreen}
                    centered
                    maskClosable={false}
                    title={translate("common.addToHomeScreen.title", { appName: clientAppName })}
                    closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true"></i>}
                    onOk={props.toggleAccount}
                    onCancel={props.toggleAccount}
                    footer={[
                        <Button key="ok" className="w-50 d-flex justify-content-center m-auto" type="primary" onClick={props.toggleAccount}>
                            {translate("common.buttons.ok")}
                        </Button>
                    ]}
                >
                    <p>{translate("common.addToHomeScreen.iosDescription", { appName: clientAppName })}</p>
                    <p className="text-bold">Tap <img className="tap-icon-style" src={TapIcon} alt="" /> and click '<img className="add-icon-style" src={AddIcon} alt="" />Add to Home Screen'</p>
                </Modal>
            );
        }
        else {
            return (
                <Modal
                    visible={props.isShowAddToHomeScreen}
                    centered
                    maskClosable={false}
                    title={translate("common.addToHomeScreen.title", { appName: clientAppName })}
                    closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true"></i>}
                    onOk={openPwaPopup}
                    onCancel={props.toggleAccount}
                    footer={[
                        <Button key="cancel" onClick={props.toggleAccount}>
                            {translate("common.buttons.cancel")}
                        </Button>,
                        <Button
                            key="ok"
                            onClick={openPwaPopup}
                            type="primary">
                            {translate("common.buttons.addToHomeScreen")}
                        </Button>
                    ]}
                >
                    <p>{translate("common.addToHomeScreen.description", { appName: clientAppName })}</p>
                </Modal>
            );
        }
    }

    return (
        renderComp()
    );
};

export default AddToHomeScreen;